export default __webpack_public_path__ + "static/media/Graco_Logo_Horiz_White.11ae0fb1.png";